import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardText } from 'react-bootstrap';
import './Manchete.css';
import mancheteImg from '../../img/Voluntariado.jpg';

function Manchete() {

  const [noticia, setNoticia] = useState(null);

  function formatarData(dataString) {
    const data = new Date(dataString); // Cria um objeto Date
    const dia = data.getDate();
    const mes = data.getMonth() + 1; // Os meses em JavaScript são de 0 a 11
    const ano = data.getFullYear();
    const nomeMes = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"][mes - 1];
    return `${dia} de ${nomeMes} de ${ano}`;
  }

  useEffect(() => {
      const storedNoticia = localStorage.getItem('selectedNoticia');
      // console.log(storedNoticia);
      if (storedNoticia) {
        setNoticia(JSON.parse(storedNoticia));
        // console.log(JSON.parse(storedNoticia).titulo);
      }
    });

    if (!noticia) {
      return <div>Loading...</div>; 
    }


  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={8}>
          <Card>
            <Card.Body>
              <Card.Title as="h1" id="mancheteTitle">{noticia.titulo} </Card.Title>
              <div class="entry-divider is-divider small"></div>
              <Card.Title as="h3" id="mancheteData">Postado em <span style={{color:'#008050', fontWeight:'bold'}}>{formatarData(noticia.data_publicacao)}</span> por <span style={{color:'#008050', fontWeight:'bold'}}>Unimed Uberlândia.</span></Card.Title>
              <Card.Img variant="top" src={noticia.caminho_imagem} className="my-4" id="mancheteImg" />
              <Card.Text id="mancheteTexto" dangerouslySetInnerHTML={{ __html: noticia.conteudo }} />
                {/* {noticia.conteudo} */}
                {/* <CardText>
                  O Instituto Unimed nasce com um forte compromisso de contribuir com o desenvolvimento da comunidade e o voluntariado é uma iniciativa importante nessa construção. Apesar de ser um movimento que nasceu do engajamento de pessoas físicas, as ações voluntárias realizadas por empresas e organizações, vem crescendo consideravelmente. A vontade de contribuir com o desenvolvimento social e a busca pela geração de valor nas localidades em que estão inseridas, fortaleceu as ações voluntárias organizadas por empresas.
                </CardText>
                <CardText>
                  Nesse contexto, empresas têm mobilizado seus colaboradores, colocando à disposição da comunidade conhecimentos e recursos que possibilitam o desenvolvimento de vários projetos.
                </CardText>
                <CardText>
                  Em termos de sustentabilidade corporativa, o voluntariado pode ser um importante pilar do ESG (Ambiental, Social e Governança. Ao incentivar e apoiar iniciativas de voluntariado, as empresas demonstram seu compromisso com a responsabilidade social e a promoção do bem-estar da sociedade. Além disso, o voluntariado corporativo está alinhado com os Objetivos de Desenvolvimento Sustentável (ODS), ao incentivar que as ações voluntárias contribuam com o atingimento das metas relacionadas, por exemplo, à educação de qualidade, saúde e bem-estar, redução das desigualdades, entre outros.
                </CardText>
                <h3 class="subTitle">
                  Benefícios Mútuos
                </h3>
                <Card.Text>
                  Falar de voluntariado corporativo é falar de uma inciativa em que todos os envolvidos (comunidade, empresa e voluntários) são beneficiados. A comunidade, que é muitas vezes representada pelas organizações sociais, possuem necessidades latentes e contantes. Para este público, o voluntariado corporativo pode trazer impactos positivos concretos, como melhoria da qualidade de vida, acesso a recursos e serviços e fortalecimento da coesão social.
                </Card.Text>
                <Card.Text>
                  Para os voluntários, a prática pode proporcionar um senso de propósito, realização pessoal e o desenvolvimento de habilidades e competências, como trabalho em equipe, empatia e liderança.
                </Card.Text>
                <Card.Text>
                  Para as empresas, o voluntariado pode aumentar a satisfação dos colaboradores, fortalecer o engajamento interno, melhorar o clima organizacional e até mesmo atrair talentos alinhados com os valores da empresa. Vale ressaltar que todo investimento e contribuição tem grande valor, especialmente, aquele que acontece de forma qualificada e organizada.
                </Card.Text>
                <h3 class="subTitle">
                  Conclusão
                </h3>
                <Card.Text>
                  Em resumo, o voluntariado corporativo possui um poder transformador tanto para quem pratica quanto para quem recebe os benefícios. Ao integrar o voluntariado em sua estratégia, as empresas podem não apenas cumprir um papel social importante, mas também fortalecer sua atuação no mercado, contribuindo para um mundo mais sustentável e justo, promovendo a cidadania ativa.
                </Card.Text> */}
              {/* </Card.Text> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Manchete;
